/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    AddAPhotoOutlined,
    AdUnitsOutlined,
    ArticleOutlined,
    BadgeOutlined,
    CampaignOutlined,
    CategoryOutlined,
    LayersOutlined,
    LocalShippingOutlined,
    MenuBookOutlined,
    PetsOutlined,
    ShoppingCartOutlined,
    ScatterPlotOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_Catalogo from "./Secciones/Seccion_Catalogo";
import Seccion_Categorias from "./Secciones/Seccion_Categorias";
import Seccion_Anuncios from "./Secciones/Seccion_Anuncios";
import Seccion_Pedidos from "./Secciones/Seccion_Pedidos";
import Seccion_Adicional from "./Secciones/Seccion_Adicional";
import Seccion_Tipo from "./Secciones/Seccion_Tipo";
import Seccion_Sectores from "./Secciones/Seccion_Sectores";
import Seccion_Banners from "./Secciones/Seccion_Banners";
import Seccion_Fotos from "./Secciones/Seccion_Fotos";
import Seccion_Blog from "./Secciones/Seccion_Blog";
import Seccion_Categorias_Blog from "./Secciones/Seccion_Categorias_Blog";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', p:3}}>
                <Typography>Version 0.1.1</Typography>
            </Grid>


        </Grid>
    )

}
export default Dashboard

const secciones = [
    {
        nombre: 'Pedidos',
        icono: ShoppingCartOutlined,
        camino: '/Pedidos',
        categoria: 'Pedidos',
        Componente: <Seccion_Pedidos/>
    },
    {
        nombre: 'Catalogo',
        icono: MenuBookOutlined,
        camino: '/Catalogo',
        categoria: 'Pagina',
        Componente: <Seccion_Catalogo/>
    },
    {
        nombre: 'Anuncios',
        icono: CampaignOutlined,
        camino: '/Anuncios',
        categoria: 'Pagina',
        Componente: <Seccion_Anuncios/>
    },
    {
        nombre: 'Fotos Pets',
        icono: AddAPhotoOutlined,
        camino: '/Fotos',
        categoria: 'Pagina',
        Componente: <Seccion_Fotos/>
    },
    {
        nombre: 'Blog',
        icono: ArticleOutlined,
        camino: '/Blog',
        categoria: 'Pagina',
        Componente: <Seccion_Blog/>
    },
    {
        nombre: 'Categorias',
        icono: CategoryOutlined,
        camino: '/Categorias',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Categorias/>
    },
    {
        nombre: 'Categorias Blog',
        icono: ScatterPlotOutlined,
        camino: '/CategoriasBlog',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Categorias_Blog/>
    },
    {
        nombre: 'Tipo',
        icono: PetsOutlined,
        camino: '/Tipo',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Tipo/>
    },
    {
        nombre: 'Sectores',
        icono: LocalShippingOutlined,
        camino: '/Sectores',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Sectores/>
    },
    {
        nombre: 'Banners',
        icono: AdUnitsOutlined,
        camino: '/Banners',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Banners/>
    },
    {
        nombre: 'Adicionales',
        icono: LayersOutlined,
        camino: '/Adicionales',
        categoria: 'Configuraciones',
        Componente: <Seccion_Adicional/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: false,
        Componente: <Seccion_Usuarios/>
    }
]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}